module.exports = __webpack_public_path__ + "img/40_69_014_540.f02fbc87.jpg";